import * as ReactHoverCard from "@radix-ui/react-hover-card"
import * as React from "react"

import { cva } from "./cva.ts"

const HoverCard = ReactHoverCard.Root

const HoverCardTrigger = ReactHoverCard.Trigger

const HoverCardPortal = ReactHoverCard.Portal

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof ReactHoverCard.Content>,
  React.ComponentPropsWithoutRef<typeof ReactHoverCard.Content>
>(
  (
    {
      className,
      align = "center",
      sideOffset = 8,
      collisionPadding = { top: 8, right: 8, bottom: 8, left: 8 },
      ...props
    },
    ref,
  ) => (
    <ReactHoverCard.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      collisionPadding={collisionPadding}
      className={classForHoverCardContent({ className })}
      {...props}
    />
  ),
)
HoverCardContent.displayName = ReactHoverCard.Content.displayName

const classForHoverCardContent = cva([
  "z-50 w-64 rounded bg-white overflow-hidden shadow-hover-card outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
])

export { HoverCard, HoverCardContent, HoverCardPortal, HoverCardTrigger }
